import React from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Polyline,
  OverlayView,
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "70vh",
};

const defaultCenter = {
  lat: 28.5116,
  lng: 77.2878,
};

const GoogleMapNew = ({ data }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDPMF7fzNp0C0PJbwtSFQNf1icTv2ceO4c",
  });

  if (!isLoaded) return <p>Loading map...</p>;
//   alert(JSON.stringify(data?.locklatitude))
  const lockLat = parseFloat(data?.locklatitude);
  const lockLng = parseFloat(data?.locklongitude);
  const unlockLat = parseFloat(data?.unlocklatitude);
  const unlockLng = parseFloat(data?.unlocklongitude);

  const center = {
    lat: isNaN(lockLat) ? defaultCenter.lat : lockLat,
    lng: isNaN(lockLng) ? defaultCenter.lng : lockLng,
  };

  const CustomMarker = ({ position, number }) => (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        style={{
          position: "relative",
          width: "80px",
          height: "80px",
          backgroundImage: "url(/pointer.png)",
          backgroundSize: "cover",
          textAlign: "center",
          lineHeight: "40px",
          fontSize: "14px",
          fontWeight: "bold",
          color: "white",
        }}
      >
        {number}
      </div>
    </OverlayView>
  );

  return (
    <div>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={17.5}
        mapTypeId="satellite"
      >
        {/* Pickup Marker */}
        {!isNaN(lockLat) && !isNaN(lockLng) && (
          <Marker
            position={{ lat: lockLat, lng: lockLng }}
            label="Pickup"
            icon={{
              url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
              scaledSize: new window.google.maps.Size(30, 30),
            }}
          />
        )}

        {/* Drop Marker */}
        {!isNaN(unlockLat) && !isNaN(unlockLng) && (
            <> 
            {/* console.log('martker is '); */}
            <Marker
                position={{ lat: unlockLat, lng: unlockLng }}
                label="Drop"
                icon={{
                url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                    scaledSize: new window.google.maps.Size(30, 30),
                }}
            />
          </>
        )}

        {/* Line from Pickup to Drop */}
        {!isNaN(lockLat) &&
          !isNaN(lockLng) &&
          !isNaN(unlockLat) &&
          !isNaN(unlockLng) && (
            <Polyline
              path={[
                { lat: lockLat, lng: lockLng },
                { lat: unlockLat, lng: unlockLng },
              ]}
              options={{
                strokeColor: "#FF0000",
                strokeOpacity: 0.9,
                strokeWeight: 3,
              }}
            />
          )}
      </GoogleMap>
    </div>
  );
};

export default GoogleMapNew;
